import { SEARCH_DROP_DOWN_FILTERS_LIST } from "../../../constants";
const initialState = {
  bookingInstruments: [],
  searchDropDownFilter: SEARCH_DROP_DOWN_FILTERS_LIST,
  allBookingInstruments: [],
  isTvMode: false,
};

export default initialState;
